import { KatLitFilteredElement, register } from '../../shared/base';
import { KatBlueprintWorkflow } from './';

/**
 * @component {kat-blueprint-workflow-identify} KatBlueprintWorkflowIdentify Component used to place and filter components within the identify section.
 * @slot default Blueprint content for identify section.
 */
@register(KatBlueprintWorkflow.slotMapping.identify.name)
export class KatBlueprintWorkflowIdentify extends KatLitFilteredElement {
  constructor() {
    super(
      KatBlueprintWorkflow.slotMapping.identify.name,
      KatBlueprintWorkflow.slotMapping.identify.allowed
    );
  }
}
